import { ErrorMessage, Stack } from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import React from 'react'
import { FulfilmentDetail } from '../../../../models/fulfilment'
import { Addresses } from './address/Addresses'
import { EmptyAddress } from './address/EmptyAddress'
import { useLineItemFulfillmentAddressDetails } from './popover/hooks'
import { AddressErrorsStatus } from './popover/hooks/useLineItemFulfillmentAddressDetails'

interface FulfilmentAddressProps {
  fulfillmentDetail: FulfilmentDetail | undefined
  isModalOpeningOnError?: boolean
  lineItemLocalId?: string
}

export const LineItemFulfilmentAddress: React.FC<FulfilmentAddressProps> = ({
  fulfillmentDetail,
  isModalOpeningOnError,
  lineItemLocalId,
}: FulfilmentAddressProps) => {
  const t = useT()
  const {
    isSameBillingAddress,
    formattedShippingAddress,
    formattedBillingAddress,
    isAddressEmpty,
    error,
    status,
  } = useLineItemFulfillmentAddressDetails(fulfillmentDetail)

  const shouldShowError =
    !!error &&
    (!isModalOpeningOnError ||
      status !== AddressErrorsStatus.EMPTYSHIPPING_CORRECTBILLING)

  const noShippingAddress = !fulfillmentDetail || isAddressEmpty

  const HasBillingAddressInModal =
    isModalOpeningOnError &&
    (status === AddressErrorsStatus.EMPTYSHIPPING_CORRECTBILLING ||
      status === AddressErrorsStatus.EMPTYSHIPPING_INCORRECTBILLING)

  return (
    <Stack space={4}>
      {noShippingAddress && !HasBillingAddressInModal ? (
        <EmptyAddress
          isModalOpeningOnError={isModalOpeningOnError}
          hasError={Boolean(error)}
          addressStatus={status}
          lineItemLocalId={lineItemLocalId}
        />
      ) : (
        <Addresses
          isSameBillingAddress={isSameBillingAddress}
          formattedShippingAddress={formattedShippingAddress}
          formattedBillingAddress={formattedBillingAddress}
          isModalOpeningOnError={isModalOpeningOnError}
          hasError={Boolean(error)}
          addressStatus={status}
        />
      )}
      {shouldShowError && (
        <ErrorMessage>{t(error, { _context: 'Alert text' })}</ErrorMessage>
      )}
    </Stack>
  )
}
